import {
  getColorForStatus,
  getTooltipForStatus,
  pregameStatusLive
} from '@library/utils/status';
import type { AllStatuses } from '@library/types/status';
import { Tooltip } from '@library/components/tooltip/Tooltip';
import { classNames } from '@library/utils';

export interface StatusIndicatorProps {
  boardTime?: string;
  className?: string;
  status: AllStatuses;
}

export const StatusIndicator = ({
  boardTime = undefined,
  className = '',
  status
}: StatusIndicatorProps) => {
  const pregameStatusTransform = pregameStatusLive(boardTime, status);
  const { borderColor, bgColor } = getColorForStatus(
    pregameStatusTransform || status
  );
  const tooltipText = getTooltipForStatus(pregameStatusTransform || status);

  return (
    <Tooltip childClassName="flex cursor-default" text={tooltipText}>
      <div className={className}>
        <div className={classNames(bgColor, 'relative h-2 w-2 rounded-full')}>
          <div
            className={classNames(
              borderColor,
              'animate-pulsate absolute right-[-2px] top-[-2px] h-3 w-3 rounded-full border border-solid opacity-0 [-webkit-animation-iteration-count:infinite]'
            )}
          />
          <div
            className={classNames(
              borderColor,
              'absolute right-[-2px] top-[-2px] h-3 w-3 animate-[pulsate_3s_ease-out_1500ms] rounded-full border border-solid opacity-0 [-webkit-animation-iteration-count:infinite]'
            )}
          />
        </div>
      </div>
    </Tooltip>
  );
};
